import React from "react";
import { FaThumbsUp, FaThumbsDown } from "react-icons/fa";
import { Translate } from "react-redux-i18n";
import Rating from "./Rating";
import "./styles/ModalCalification.css";

function CalificationModalForm({
  isConfirmed,
  description,
  onChangeDescription,
  onClickRating,
  onSelectSentiment,
  onClose,
  onSubmit,
}) {
  return (
    <div className="calification-modal">
      <div className="calification-modal-hero">
        <p className="calification-modal-hint">
          <Translate value="calification_transaction_hint" />
        </p>
        <div className="calification-modal-sentiment-row">
          <button
            type="button"
            className={
              "calification-modal-sentiment-btn calification-modal-sentiment-btn--positive" +
              (isConfirmed === true ? " calification-modal-sentiment-btn--active" : "")
            }
            onClick={() => onSelectSentiment(true)}
            aria-label="Positive"
          >
            <FaThumbsUp />
          </button>
          <button
            type="button"
            className={
              "calification-modal-sentiment-btn calification-modal-sentiment-btn--negative" +
              (isConfirmed === false ? " calification-modal-sentiment-btn--active" : "")
            }
            onClick={() => onSelectSentiment(false)}
            aria-label="Negative"
          >
            <FaThumbsDown />
          </button>
        </div>
        {isConfirmed !== null && (
          <p className="calification-modal-sentiment">
            <Translate
              value={isConfirmed ? "feedback_good" : "feedback_bad"}
            />
          </p>
        )}
      </div>

      <div className="calification-modal-rating">
        <Rating
          key={isConfirmed === null ? "none" : isConfirmed ? "up" : "down"}
          variant="modal"
          onClickRating={onClickRating}
        />
      </div>

      <div className="calification-modal-field">
        <label className="calification-modal-label" htmlFor="calification_comment">
          <Translate value="comments" />
        </label>
        <textarea
          id="calification_comment"
          className="calification-modal-textarea"
          name="comment"
          rows={4}
          value={description}
          onChange={onChangeDescription}
        />
      </div>

      <div className="calification-modal-footer">
        <button
          type="button"
          className="calification-modal-btn calification-modal-btn--secondary"
          onClick={onClose}
        >
          <Translate value="close" />
        </button>
        <button
          type="button"
          className="calification-modal-btn calification-modal-btn--primary"
          onClick={onSubmit}
        >
          <Translate value="feedback_send" />
        </button>
      </div>
    </div>
  );
}

export default CalificationModalForm;
